// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function Conversation__ConversationsSection__SendMessageButtons$SendPublicMessageButton(props) {
  let onSubmit = props.onSubmit;
  return JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
    onClick: param => onSubmit(),
    disabled: props.submitDisabled,
    children: "Send a new public message"
  });
}

let SendPublicMessageButton = {
  make: Conversation__ConversationsSection__SendMessageButtons$SendPublicMessageButton
};

function Conversation__ConversationsSection__SendMessageButtons$SendPrivateMessageButton(props) {
  let onSubmit = props.onSubmit;
  return JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
    onClick: param => onSubmit(),
    disabled: props.submitDisabled,
    children: "Send private message"
  });
}

let SendPrivateMessageButton = {
  make: Conversation__ConversationsSection__SendMessageButtons$SendPrivateMessageButton
};

let Buttons;

exports.Buttons = Buttons;
exports.SendPublicMessageButton = SendPublicMessageButton;
exports.SendPrivateMessageButton = SendPrivateMessageButton;
/* ButtonsV5 Not a pure module */
